export default __webpack_public_path__ + "static/media/10.a92af605.jpg";